<nav class="footer" [ngClass]="currentBg()">
  <div class="container-fluid container-p-x pb-3">
    <a href="https://www.merkator.com/contact" class="footer-link pt-3" target="_blank">Contact Helpdesk</a>
    <a href="http://www.Fetrapi.be" class="footer-link pt-3 ms-4">Fetrapi home page</a>
    @if (!isLogin) {
      <a href="https://merkatorfetrapistoreacc.blob.core.windows.net/docs/Fetrapi_UserManual.pdf" class="footer-link pt-3 ms-4" target="_blank">User Help</a>
      <label class="footer-link pt-3 ms-4">Fetrapi Portal v{{portalVersion}}</label>
    }
    @if (isAcceptance) {
      <label class="footer-link pt-3 ms-4 float-end text-danger">
        THIS IS THE FETRAPI ACCEPTANCE PORTAL. DO NOT USE FOR PRODUCTION DATA
      </label>
    }
  </div>
</nav>
